<cbc-container [isLoading]="isLoading" [showContainer]="!isLoading" title="Atendimentos"
  description="Gerencie os atendimentos registrados no sistema">
</cbc-container>

@if(!isLoading) {
<div class="container">

  <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
    <mat-tab label="Atendimentos Abertos">
      <div class="slideContainer">
        @if(getCustomerServiceOpen().length > 0) {
        <div class="card">
          <table mat-table [dataSource]="getCustomerServiceOpen()" multiTemplateDataRows>
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>Número</th>
              <td mat-cell *matCellDef="let element">
                <span class="badge badge-primary">{{ element.id }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="subject">
              <th mat-header-cell *matHeaderCellDef>Assunto</th>
              <td mat-cell *matCellDef="let element">
                {{ element.subject || '-' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="registerDateOpen">
              <th mat-header-cell *matHeaderCellDef>Aberto em</th>
              <td mat-cell *matCellDef="let element">
                {{ element.registerDateOpen | date : "dd/MM/yyyy '-' HH:mm" }}
              </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>Status</th>
              <td mat-cell *matCellDef="let element">
                <span class="badge badge-warning">{{ element.status | enumDescription }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="buttons">
              <th mat-header-cell *matHeaderCellDef class="col-actions">Ações</th>
              <td mat-cell *matCellDef="let element" class="col-actions">
                <button mat-icon-button [matMenuTriggerFor]="actionsMenu" class="btn-ghost">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #actionsMenu="matMenu">
                  <button mat-menu-item (click)="openDialogChat(element.id)">
                    <mat-icon>chat</mat-icon>
                    <span>Chat</span>
                  </button>
                  <button mat-menu-item (click)="planStatusOverview(element.userCpf)">
                    <mat-icon>info</mat-icon>
                    <span>Status de planos</span>
                  </button>
                  @if(element.subject?.includes('Solicito certificado')) {
                  <button mat-menu-item (click)="certify(element.subject, element.id!)">
                    <mat-icon>verified</mat-icon>
                    <span>Certificar</span>
                  </button>
                  }
                  <mat-divider></mat-divider>
                  <button mat-menu-item (click)="closeCustomerService(element)">
                    <mat-icon color="primary">done</mat-icon>
                    <span>Concluir atendimento</span>
                  </button>
                </mat-menu>

                <button mat-icon-button
                  (click)="expandedElement = expandedElement === element ? null : element; $event.stopPropagation()">
                  <mat-icon>
                    {{ expandedElement === element ? "keyboard_arrow_up" : "keyboard_arrow_down" }}
                  </mat-icon>
                </button>
              </td>
            </ng-container>

            <ng-container matColumnDef="expandedDetail">
              <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumnsCSOpen.length">
                <div class="expanded-detail" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                  <div class="card card-dark">
                    <div class="card-header">
                      <div class="card-title">Detalhes do Atendimento #{{ element.id }}</div>
                    </div>
                    <div class="card-body">
                      <pre>{{ element | json }}</pre>
                    </div>
                  </div>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumnsCSOpen"></tr>
            <tr mat-row *matRowDef="let element; columns: displayedColumnsCSOpen"
              [class.expanded-row]="expandedElement === element"></tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
          </table>
        </div>
        } @else {
        <div class="card">
          <div class="card-body">
            <p class="text-center text-muted">Nenhum atendimento aberto no momento.</p>
          </div>
        </div>
        }
      </div>
    </mat-tab>

    <mat-tab label="Atendimentos Fechados">
      <div class="slideContainer">
        @if(getCustomerServiceClose().length > 0) {
        <div class="card">
          <table mat-table [dataSource]="getCustomerServiceClose()" multiTemplateDataRows>
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>Número</th>
              <td mat-cell *matCellDef="let element">
                <span class="badge badge-primary">{{ element.id }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="subject">
              <th mat-header-cell *matHeaderCellDef>Assunto</th>
              <td mat-cell *matCellDef="let element">
                {{ element.subject || '-' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="registerDateOpen">
              <th mat-header-cell *matHeaderCellDef>Aberto em</th>
              <td mat-cell *matCellDef="let element">
                {{ element.registerDateOpen | date : "dd/MM/yyyy '-' HH:mm" }}
              </td>
            </ng-container>

            <ng-container matColumnDef="registerDateClose">
              <th mat-header-cell *matHeaderCellDef>Concluído em</th>
              <td mat-cell *matCellDef="let element">
                {{ element.registerDateClose | date : "dd/MM/yyyy '-' HH:mm" }}
              </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>Status</th>
              <td mat-cell *matCellDef="let element">
                <span class="badge badge-success">{{ element.status | enumDescription }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="buttons">
              <th mat-header-cell *matHeaderCellDef class="col-actions">Ações</th>
              <td mat-cell *matCellDef="let element" class="col-actions">
                <button mat-icon-button [matMenuTriggerFor]="actionsMenuClosed" class="btn-ghost">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #actionsMenuClosed="matMenu">
                  <button mat-menu-item (click)="openDialogChat(element.id)">
                    <mat-icon>chat</mat-icon>
                    <span>Chat</span>
                  </button>
                </mat-menu>

                <button mat-icon-button
                  (click)="expandedElement = expandedElement === element ? null : element; $event.stopPropagation()">
                  <mat-icon>
                    {{ expandedElement === element ? "keyboard_arrow_up" : "keyboard_arrow_down" }}
                  </mat-icon>
                </button>
              </td>
            </ng-container>

            <ng-container matColumnDef="expandedDetail">
              <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumnsCSClose.length">
                <div class="expanded-detail" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                  <div class="card card-dark">
                    <div class="card-header">
                      <div class="card-title">Detalhes do Atendimento #{{ element.id }}</div>
                    </div>
                    <div class="card-body">
                      <pre>{{ element | json }}</pre>
                    </div>
                  </div>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumnsCSClose"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsCSClose"></tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
          </table>
        </div>
        } @else {
        <div class="card">
          <div class="card-body">
            <p class="text-center text-muted">Nenhum atendimento fechado no momento.</p>
          </div>
        </div>
        }
      </div>
    </mat-tab>
  </mat-tab-group>

</div>
}